<template>
    <div class="auth">
        <mu-row justify-content="center" align-items="center">
            <mu-col span="12" sm="12" md="7" lg="5" xl="5">

                <div class="reset" v-if="!loading.status">
                    <mu-title type="h2" color="primary" textStrong="700">Gerar nova senha</mu-title>
                    <hr>
                    <mu-form ref="form" :model="form">
                        <mu-form-item label="Digite seu login" prop="username">
                            <mu-text-field v-model="form.username" prop="username"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item label="Digite sua nova senha" prop="password">
                            <mu-text-field type="password" v-model="form.password" @focus="verifyFocus()" @blur="verifyFocus()" prop="password"></mu-text-field>
                            <small class="info-form" v-if="passFocus">A senha deve ter pelo menos 6 caracteres e ser composta por letras maiúsculas, minúsculas e números!</small>
                        </mu-form-item>
                        <mu-form-item label="Repita a senha" prop="repeat_password">
                            <mu-text-field type="password" v-model="form.repeat_password" prop="repeat_password" :error-text="(form.password && form.repeat_password && form.password !== form.repeat_password ? 'As senhas não conferem...' : '')"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item>
                            <mu-button round color="primary" @click="reset()" :disabled="!form.username || !form.password || !form.repeat_password || !form.token">Salvar</mu-button>
                            <router-link :to="{ name: 'auth.login' }">
                                <mu-flex>
                                    <span>Ir para o login</span> <font-awesome-icon icon="arrow-left" />
                                </mu-flex>
                            </router-link>
                        </mu-form-item>
                    </mu-form>
                </div>

                <div class="loading" v-if="loading.status">
                    <mu-circular-progress color="primary" :stroke-width="1" :size="36"></mu-circular-progress>
                    <p>Aguarde enquanto validamos seus dados.</p>
                </div>

                <div class="version left">
                    {{ version }}
                </div>

            </mu-col>
            <mu-col span="12" sm="12" md="5" lg="7" xl="7" class="login-bg">
                <mu-flex justify-content="center" align-items="center" class="svg">
                    <img src="/svg/login/icons.svg" alt="">
                </mu-flex>
            </mu-col>
        </mu-row>

        <!-- Snackbar -->
        <mu-snackbar position="bottom-start" :color="snackbar.type" :open.sync="snackbar.open">
            {{ snackbar.message }}
            <mu-button flat slot="action" color="#fff" @click="snackbar.open = false">Fechar</mu-button>
        </mu-snackbar>

    </div>
</template>

<script>
    import resetPassword from '@/services/auth/reset-password'
    // import * as Sentry from '@sentry/browser'
    import { version } from '@/../package.json'

    // ------------------------------------------------------------------------------------------

    // Configuração do sentry para logs do front
    // if (process.env.VUE_APP_SENTRY_DSN) {
    //     Sentry.init({
    //         dsn: process.env.VUE_APP_SENTRY_DSN,
    //         environment: process.env.NODE_ENV || 'development'
    //     })
    // }

    // ------------------------------------------------------------------------------------------

    export default {
        name: 'reset',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                version: `v.${version}`,
                loading: {
                    status: false,
                    message: ''
                },
                form: {
                    token: this.$route.params.token,
                    username: '',
                    password: '',
                    repeat_password: ''
                },
                snackbar: {
                    type: '',
                    message: '',
                    open: false,
                    timeout: 4000
                },
                passFocus: false
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            verifyFocus () {
                this.passFocus = !this.passFocus
            },

            /**
             * Método para resetar a nova senha
             */
            async reset () {
                try {
                    if (!this.$route.params.token) {
                        this.$eventHub.$emit('snackbar', 'error', 'Não existe um token para poder atualizar.', false)
                        return
                    }
                    this.loading.status = true
                    this.loading.message = 'Enviando sua nova senha para atualizar.'

                    let result = await resetPassword(this.form)
                    if (result.status) {
                        this.snackbarMessage('success', result.message)
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.snackbarMessage('error', e.message || 'Não foi possível salvar a nova senha.')
                } finally {
                    this.loading.status = false
                    this.loading.message = ''
                }
            },

            /**
             * Controle do snackbar para o alerta das mensagens
             */
            snackbarMessage (type, message) {
                this.snackbar.open = true
                this.snackbar.type = type
                this.snackbar.message = message
                setTimeout(() => {
                    this.snackbar.open = false
                }, this.snackbar.timeout)
            }
        }
    }
</script>

<style lang="stylus">

    @import './../../assets/stylus/bootstrap.styl'

    // Mobile First

    body, html
        height 100%

    .auth

        height 100%

        .row
            height 100%

        .version
            position fixed
            bottom 5px
            color #666
            left 5px
            font-size 11px

        .reset
            max-width 350px
            margin auto
            margin-bottom 30px
            padding 15px

            hr
                border 0
                border-bottom 2px $primary solid
                width 20px
                margin 5px 0 20px 0

            a
                color #999
                font-size 12px
                margin-left 30px
                span
                    text-decoration underline
                i
                    font-size 20px
                    margin 0 4px

                &:hover
                    color $primary

            .mu-form-item-label
                color #999
                font-size 12px

            .mu-button
                margin 0

        .loading
            text-align center
            color #888
            font-size 12px

        .login-bg
            display none

        .info-form
            color $primary
            font-size 11px
            margin-top 5px

    /* Acima de 700 pixels */
    @media (min-width: 700px)

        .auth

            .login-bg
                background url('/img/login-background.jpg') no-repeat center center
                background-size cover
                height 100%
                display block

                .svg
                    height 100%

                img
                    max-width 80%
                    max-height 80%

</style>
